import { CALL_API } from 'redux-api-middleware'
import {
  LOAD_HOME_PAGES_SIDE_REQUEST,
  LOAD_HOME_PAGES_SIDE_SUCCESS,
  LOAD_HOME_PAGES_SIDE_FAILURE,
  LOAD_HOME_PAGES_ALL_REQUEST,
  LOAD_HOME_PAGES_ALL_SUCCESS,
  LOAD_HOME_PAGES_ALL_FAILURE,
  LOAD_LEVEL_REQUEST,
  LOAD_LEVEL_SUCCESS,
  LOAD_LEVEL_FAILURE,
  LOAD_CATEGORY_REQUEST,
  LOAD_CATEGORY_SUCCESS,
  LOAD_CATEGORY_FAILURE,
  // LOAD_SCHOOL_REQUEST,
  LOAD_SCHOOL_SUCCESS,
  // LOAD_SCHOOL_FAILURE,
  LOAD_SCHOOLGET_REQUEST,
  LOAD_SCHOOLGET_SUCCESS,
  LOAD_SCHOOLGET_FAILURE,
  LOAD_PROVINCESCHOOL_REQUEST,
  LOAD_PROVINCESCHOOL_SUCCESS,
  LOAD_PROVINCESCHOOL_FAILURE,
  LOAD_HOME_COURSE_ALL_REQUEST,
  LOAD_HOME_COURSE_ALL_SUCCESS,
  LOAD_HOME_COURSE_ALL_FAILURE,
  LOAD_LIVE_PAGE_REQUEST,
  LOAD_LIVE_PAGE_SUCCESS,
  LOAD_LIVE_PAGE_FAILURE,
  LOAD_LIVE_REPLAY_REQUEST,
  LOAD_LIVE_REPLAY_SUCCESS,
  LOAD_LIVE_REPLAY_FAILURE,
  LOAD_LIVE_NOW_REQUEST,
  LOAD_LIVE_NOW_SUCCESS,
  LOAD_LIVE_NOW_FAILURE,
  LOAD_LIVE_COMING_REQUEST,
  LOAD_LIVE_COMING_SUCCESS,
  LOAD_LIVE_COMING_FAILURE,
  LOAD_BANNER_REQUEST,
  LOAD_BANNER_SUCCESS,
  LOAD_BANNER_FAILURE,
} from './types'

import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const loadHomePageSide = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_HOME_PAGES_SIDE_REQUEST,
      LOAD_HOME_PAGES_SIDE_SUCCESS,
      LOAD_HOME_PAGES_SIDE_FAILURE,
    ],
  },
})

export const loadHomePageAll = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_HOME_PAGES_ALL_REQUEST,
      LOAD_HOME_PAGES_ALL_SUCCESS,
      LOAD_HOME_PAGES_ALL_FAILURE,
    ],
  },
})

export const loadCourseAll = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_HOME_COURSE_ALL_REQUEST,
      LOAD_HOME_COURSE_ALL_SUCCESS,
      LOAD_HOME_COURSE_ALL_FAILURE,
    ],
  },
})
export const loadBanner = (endpoint, filter = null) => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_BANNER_REQUEST,
      {
        type: LOAD_BANNER_SUCCESS,
        payload: async (action, state, res) => {
          const response = await res.json()
          if(filter !== null)
            return response.filter(banner => banner.showPage === filter)
          return response
        },
      },
      LOAD_BANNER_FAILURE,
    ],
  },
})
export const loadLivePage = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_LIVE_PAGE_REQUEST,
      {
        type: LOAD_LIVE_PAGE_SUCCESS,
        payload: async (action, state, res) => {
          const response = await res.json()
          var comingLive=[]
          var currentLive=[]
          var previousLive=[]
          currentLive = response.filter(live => live.startTime <= Date.now() && live.endTime >= Date.now())
          comingLive = response.filter(live => live.startTime > Date.now() && live.endTime > Date.now())
          previousLive = response.filter(live => live.startTime < Date.now() && live.endTime < Date.now())
          let lives = {
            currentLive,
            comingLive,
            previousLive,
          }
          // response.currentLive = currentLive
          // response.comingLive = comingLive
          // response.push({'category':cateName})
          // onsetProductByCate(response)
          // cateArr.push({'category':,'products':response.products})
          return lives
        },
      },
      LOAD_LIVE_PAGE_FAILURE,
    ],
  },
})
export const loadLiveReplay = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_LIVE_REPLAY_REQUEST,
      {
        type: LOAD_LIVE_REPLAY_SUCCESS,
        payload: async (action, state, res) => {
          const response = await res.json()
          return response
        },
      },
      LOAD_LIVE_REPLAY_FAILURE,
    ],
  },
})
export const loadLiveNow = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_LIVE_NOW_REQUEST,
      {
        type: LOAD_LIVE_NOW_SUCCESS,
        payload: async (action, state, res) => {
          const response = await res.json()
          return response
        },
      },
      LOAD_LIVE_NOW_FAILURE,
    ],
  },
})
export const loadLiveComing = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_LIVE_COMING_REQUEST,
      {
        type: LOAD_LIVE_COMING_SUCCESS,
        payload: async (action, state, res) => {
          const response = await res.json()
          return response
        },
      },
      LOAD_LIVE_COMING_FAILURE,
    ],
  },
})

export const loadLevels = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_LEVEL_REQUEST,
      LOAD_LEVEL_SUCCESS,
      LOAD_LEVEL_FAILURE,
    ],
  },
})

export const loadCategory = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_CATEGORY_REQUEST,
      LOAD_CATEGORY_SUCCESS,
      LOAD_CATEGORY_FAILURE,
    ],
  },
})

export const loadSchool = (data) => {
  return {
    type: LOAD_SCHOOL_SUCCESS,
    data,
  }
}
export const loadSchoolGet = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_SCHOOLGET_REQUEST,
      LOAD_SCHOOLGET_SUCCESS,
      LOAD_SCHOOLGET_FAILURE,
    ],
  },
})
export const loadProvince = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      LOAD_PROVINCESCHOOL_REQUEST,
      LOAD_PROVINCESCHOOL_SUCCESS,
      LOAD_PROVINCESCHOOL_FAILURE,
    ],
  },
})




// WEBPACK FOOTER //
// ./src/actions/home.js